module.exports = __webpack_public_path__ + "img/badge_standard_simple.b646097c.png";